module.exports = __webpack_public_path__ + "img/slide3.46a8e18c.svg";